<template>
  <v-dialog
      v-model="value"
      persistent
      :content-class="'create_new_account_modal'"
      max-width="550"
  >
    <div class="heading">
      <h2 class="heading_new_account">Confirm Join</h2>
    </div>
    <div class="wrapper_content h165 v_center">
      <div class="account_issue_box">
        You do not own this artist.
        <span style="cursor: pointer;" @click="redirectToOwner">
          {{ account && account.owner ? account.owner.fullName : '' }}
        </span>
        will be notified and their explicit approval will be required for the release to become published.
      </div>
    </div>
    <div class="wrapper_button center">
      <button type="button" class="tetriatary_btn" v-ripple @click="$emit('cancel')">Back</button>
      <button type="button" class="tetriatary_btn" v-ripple @click="$emit('confirm')">Continue</button>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmJoinArtistDialog',
  props: {
    value: Boolean,
    account: Object,
  },
  methods: {
    redirectToOwner() {
      if (this.account?.owner?.id && this.account?.owner?.identifier) {
        this.$router.push({
          name: 'user-profile',
          params: {
            id: this.account.owner.id,
            name: window.toHumanFormat(this.account.owner.identifier),
          },
        });
      }
    },
  },
};
</script>
